import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { action } from 'satcheljs/lib/legacy';

/**
 * Called to update the currently hovered item on surface.
 * @newValue The newly selected item
 * @store The surface store
 */
export let updateHoveredItem = action('updateHoveredItems')(function updateHoveredItems(
    newValue: CalendarEvent,
    store: CalendarSurfaceStore
) {
    if (store.hoveredItem != newValue) {
        store.hoveredItem = newValue;
    }
});
